var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"icon":"","variant":"link","depressed":"","tile":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('b-icon',{attrs:{"icon":"credit-card","variant":"primary","aria-hidden":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }